import React, { useEffect } from 'react';
import { connect } from 'redux-zero/react';
import { combineActions } from 'redux-zero/utils';
import { get } from 'lodash';
import { formActions, holderActions } from 'app/state/actions';
import { AuthenticationService, HolderService, TokenService /*, MessageService */ } from 'services';
import { DsLoader } from '@tokenyico/design-system/dist/reactJS';

const portalId = process.env.REACT_APP_PORTAL_ID;

const SSOLogin = ({
  location,
  history,
  setError,
  setTokens,
  //  setMessages,
  setSelectedToken,
  setBalances,
  setUser,
}) => {
  const query = new URLSearchParams(location.search);
  useEffect(() => {
    // god damn react
    (async () => {
      try {
        await AuthenticationService.SSOSignIn({ jwt: query.get('jwt') });
        let tokenId;
        // let tokenAddress;
        if (portalId) {
          const tokens = await TokenService.getTokens();
          if (tokens && tokens.length === 0) {
            throw new Error(t('validation.notAuthorizedRegistered'));
          }
          setTokens(tokens);
          const selectedToken = TokenService.getSelectedToken(tokens);
          setSelectedToken(selectedToken);
          tokenId = selectedToken.id;
          // tokenAddress = selectedToken.address;
        } else {
          tokenId = process.env.REACT_APP_TOKEN_ID;
          const balances = await HolderService.getBalances(tokenId);
          setBalances(balances);
          setSelectedToken(get(balances, '[0].token', null));
          // tokenAddress = get(balances, '[0].token.address', null);
        }

        const currentTokenHolder = await HolderService.getTokenHolder(tokenId);
        if (currentTokenHolder && currentTokenHolder.status === 'Registered') {
          throw new Error(t('validation.notAuthorizedRegistered'));
        }
        setUser(currentTokenHolder);

        // MessageService.getAllMessages(tokenAddress).then(setMessages);

        history.push('/dashboard');
      } catch (error) {
        setError(error);
      }
    })();
  }, [location]);
  return <DsLoader />;
};

export default connect((state) => state, combineActions(formActions, holderActions))(SSOLogin);
